
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
// eslint-disable-next-line
import ScrollToType from '@/components/scroll_to/type'
import { WinpressModule } from '@/store/modules/winpress'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { WinpressService } from '@/services'
import { addImgHost, calcPageIndex, createImageViewTo } from '@/common/utils'

@Component({
    name: 'media-store',
    components: {
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private pageSize = 50
    private pageIndex = 1
    private pageTotal = 0
    private typeId = ''
    private isLoading = true
    private articleList = []

    get createLink() {
        return `/content/winpress/article/${this.$route.params.id}/create`
    }
    get articleTypes() {
        return [
            { id: '', name: '全部文章' },
            ...WinpressModule.articleTypes
        ]
    }
    created() {
        this.$title('文章列表 | 麦媒云 - 庖丁')   
    }
    mounted() {
        this.initData()    
    }
    async fetchData() {
        const params = {
            type_id: this.typeId,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await WinpressService.getArticleList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.articleList = result.data.list.map((article: any) => {
                // 处理封面图：如果已经包含 http 则直接使用，否则拼接 IMG_HOST
                let coverImg = ''
                if (article.coverImg) {
                    const rawImg = article.coverImg
                    // 如果已经是完整 URL，直接使用
                    if (rawImg.includes('http')) {
                        coverImg = rawImg
                    } else {
                        // 否则用 addImgHost 拼接
                        coverImg = addImgHost(rawImg)
                    }
                }
                console.log('图片处理:', { raw: article.coverImg, processed: coverImg })
                return {
                    ...article,
                    coverImg
                }
            })

        }
    }
    async initData() {
        await this.getArticleTypes()
        await this.fetchData()
        this.isLoading = false
    }
    onToArticleDetail(id: string | number) {
        window.open(`/content/winpress/article/${id}`)
    }
    onDelete(id: string | number) {
        this.$confirm('正在执行删除操作, 你确定吗老铁?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.deleteArticle(id)
        })
    }
    async deleteArticle(id: string | number) {
        const params = { id }
        const result = await WinpressService.deleteArticle(params)
        if (result.status === 200) {
            this.pageIndex = calcPageIndex(this.articleList.length, this.pageIndex)
            this.fetchData()
            return this.$msuccess('删除成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(() => {
            // todo
        })
    }
    async getArticleTypes() {
        await WinpressModule.getArticleTypes()
        this.typeId = this.articleTypes.find(n => String(n.id) === this.$route.params.id).id
    }
}
